import { Button } from "@material-ui/core";
import { BLUE_PRIMARY, ERROR_COLOR } from "../../utils/const";

const DeviceAbstract = ({ changeTab, info, data }) => {
  const headers = [
    { title: "نام دستگاه", data: "name" },
    { title: "ارتفاع مخزن", data: "height" },
    { title: "ارتفاع فعلی", data: "currentHeight" },
    { title: "ارتفاع سنسور بالا", data: "topLimit" },
    { title: "ارتفاع سنسور پایین", data: "lowLimit" },
    { title: "ایجاد دستور", data: "isOrderable" },
  ];
  const renderBtn = (isOrderable) => {
    return (
      <Button
        onClick={(e) => changeTab(e, "4")}
        style={{
          color: "#fff",
          marginRight: "4px",
          backgroundColor: isOrderable ? BLUE_PRIMARY : ERROR_COLOR,
        }}
        variant="contained"
        disabled={!isOrderable}
      >
        {isOrderable ? "دارد" : "ندارد"}
      </Button>
    );
  };
  const abstractData = {
    name: info?.water_meter_name,
    height: `${info?.other_information?.tank_height} (mm)`,
    currentHeight: `${info?.other_information?.position - data.value} (mm)`,
    topLimit: `${info?.other_information?.up_sensor} (mm)`,
    lowLimit: `${info?.other_information?.down_sensor} (mm)`,
    isOrderable: renderBtn(true),
  };

  return (
    <>
      {headers.map((item, idx) => (
        <div
          key={idx}
          style={{
            margin: "13px auto",
          }}
        >
          <span style={{ fontWeight: "600", marginLeft: "8px" }}>
            {item.title}
            {":"}
          </span>
          <span>{abstractData[item.data]}</span>
        </div>
      ))}
    </>
  );
};
export default DeviceAbstract;
